"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.makeGetRouteWayPoints = exports["default"] = exports.Route = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _map = require("@nicbase/map");

var _helpers = require("@turf/helpers");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _routeSectionPoiMarker = require("./route-section-poi-marker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var makeGetRouteWayPoints = function makeGetRouteWayPoints() {
  return (0, _reselect.createSelector)(function (state) {
    return state.informationLists.pois;
  }, function (state, props) {
    return props.tour.wayPoints;
  }, function (pois, wayPoints) {
    return wayPoints.reduce(function (result, wayPoint) {
      var p = pois.find(function (poi) {
        return poi.id === wayPoint.poiId;
      });

      if (p) {
        var latitude = p.latitude,
            longitude = p.longitude,
            name = p.name,
            category = p.category,
            id = p.id;
        result.push({
          id: id,
          lat: latitude,
          lng: longitude,
          name: name,
          category: category.icon
        });
      }

      return result;
    }, []);
  });
};

exports.makeGetRouteWayPoints = makeGetRouteWayPoints;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var getTourWaypoints = makeGetRouteWayPoints();
  return {
    wayPoints: getTourWaypoints(state, ownProps)
  };
};

exports.mapStateToProps = mapStateToProps;

var Route = function Route(_ref) {
  var _tour$route, _tour$route2;

  var tour = _ref.tour,
      wayPoints = _ref.wayPoints;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id; // request to load the current route of the tour


  var _usePortalFindRoute = (0, _hooks.usePortalFindRoute)({
    portalId: portalId,
    routeId: (_tour$route = tour.route) === null || _tour$route === void 0 ? void 0 : _tour$route.id,
    options: {
      enabled: Boolean((_tour$route2 = tour.route) === null || _tour$route2 === void 0 ? void 0 : _tour$route2.id),
      select: function select(route) {
        var _route$geometry$coord, _route$geometry;

        return (_route$geometry$coord = route === null || route === void 0 ? void 0 : (_route$geometry = route.geometry) === null || _route$geometry === void 0 ? void 0 : _route$geometry.coordinates) !== null && _route$geometry$coord !== void 0 ? _route$geometry$coord : [];
      }
    }
  }),
      _usePortalFindRoute$d = _usePortalFindRoute.data,
      routePoints = _usePortalFindRoute$d === void 0 ? [] : _usePortalFindRoute$d;

  var allowedDeviation = tour.route.allowedDeviation;
  var poiMarkers = (0, _react.useMemo)(function () {
    return wayPoints.map(function (waypoint) {
      var point = {
        type: 'Feature',
        geometry: {
          type: waypoint.type,
          coordinates: [waypoint.lng, waypoint.lat]
        }
      };
      return (0, _helpers.point)(point.geometry.coordinates, {
        wayPointId: waypoint.id,
        status: ['DRIVING'],
        name: waypoint.name,
        category: waypoint.category,
        draggable: false
      });
    });
  }, [wayPoints]);
  var renderPoiMarkers = (0, _react.useMemo)(function () {
    return poiMarkers.map(function (poiMarker, index) {
      return /*#__PURE__*/_react["default"].createElement(_routeSectionPoiMarker.PoiMarker, {
        start: index === 0,
        end: index === poiMarkers.length - 1,
        feature: poiMarker,
        lat: poiMarker.geometry.coordinates[1],
        lng: poiMarker.geometry.coordinates[0],
        draggable: poiMarker.draggable,
        index: index
      });
    });
  }, [poiMarkers]);
  var mapType = 'osm';

  var _useUserMap = (0, _map.useUserMap)({
    mapType: mapType
  }),
      _useUserMap$viewport = _useUserMap.viewport,
      zoom = _useUserMap$viewport.zoom,
      latitude = _useUserMap$viewport.latitude,
      longitude = _useUserMap$viewport.longitude,
      height = _useUserMap$viewport.height,
      width = _useUserMap$viewport.width,
      setViewport = _useUserMap.setViewport,
      fitBounds = _useUserMap.fitBounds;

  var _useDimensions = (0, _hooks.useDimensions)(),
      _useDimensions2 = _slicedToArray(_useDimensions, 2),
      container = _useDimensions2[0],
      _useDimensions2$ = _useDimensions2[1],
      viewPortWidth = _useDimensions2$.width,
      viewPortHeight = _useDimensions2$.height;

  (0, _react.useEffect)(function () {
    setViewport(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        height: viewPortHeight !== null && viewPortHeight !== void 0 ? viewPortHeight : 0,
        width: viewPortWidth !== null && viewPortWidth !== void 0 ? viewPortWidth : 0
      });
    });
  }, [viewPortHeight, viewPortWidth, setViewport]);
  (0, _react.useEffect)(function () {
    var features = [];

    if (poiMarkers.length > 0) {
      features = [].concat(_toConsumableArray(features), _toConsumableArray(poiMarkers));
    }

    if (features.length > 0) {
      fitBounds({
        type: 'FeatureCollection',
        features: features
      }, {
        padding: 30
      });
    }
  }, [fitBounds, poiMarkers]);
  var routeLineString = (0, _react.useMemo)(function () {
    return routePoints.length > 0 ? /*#__PURE__*/_react["default"].createElement(_map.GeoJson, {
      layerId: "route",
      featureStyle: {
        strokeOpacity: 1,
        strokeWeight: 4,
        fillColor: 'transparent'
      },
      feature: (0, _helpers.lineString)(routePoints)
    }) : null;
  }, [routePoints]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-64",
    ref: container
  }, /*#__PURE__*/_react["default"].createElement(_map.BaseMap, {
    mapType: mapType,
    zoom: zoom,
    latitude: latitude,
    longitude: longitude,
    height: height,
    width: width,
    onViewportChange: setViewport
  }, routeLineString, renderPoiMarkers)), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.allowedDeviation"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex mt-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold mr-1"
    }, message, ":"), /*#__PURE__*/_react["default"].createElement("span", null, allowedDeviation, "m"));
  }));
};

exports.Route = Route;
Route.propTypes = {
  tour: _propTypes["default"].shape({
    route: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      allowedDeviation: _propTypes["default"].number
    })
  }).isRequired,
  wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired
};
Route.defaultProps = {};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Route);

exports["default"] = _default;